import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonios } from '../data/testimonios';
import { Emoji } from './Emoji';
export function Testimonios() {
  return <section className="w-full bg-forest-900 py-20" data-id="element-240" data-mp="39zmqem0wltct">
      <div className="mx-auto max-w-[680px] px-5 text-center sm:px-8" data-id="element-241" data-mp="35yj8zv37jp9h">
        <h2 className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-cream sm:text-4xl" data-id="element-242" data-mp="311aq1sa8jh76">
          <Emoji symbol="❤️" className="text-3xl" data-id="element-243" data-mp="2w3j0h4x2c765" />
          Más personas que ya lo tienen
        </h2>

        <ul className="mt-10 flex flex-col gap-4" data-id="element-244" data-mp="2mbv0gfmfxht2">
          {testimonios.map(item => <li key={item.name + item.initials} data-id="element-245" data-mp="2m9iiw3klh9gj">
              <figure className="rounded-2xl border border-line bg-pistacho p-6 text-center shadow-card" data-id="element-246" data-mp="2ibb6tm12swbo">
                <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-lime-200 font-display text-xs font-bold text-forest-800" aria-hidden="true" data-id="element-247" data-mp="2d9vk7pj92hr6">
                  {item.initials}
                </span>
                <span className="mt-3 flex justify-center gap-0.5" aria-label="5 de 5 estrellas" data-id="element-248" data-mp="1s4b4roelvkz5">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-249" data-mp="1jbhaajql8f0p" data-mpi={index} />)}
                </span>
                <blockquote className="mt-4 text-[15px] leading-relaxed text-forest-900" data-id="element-250" data-mp="1x2combjuvobo">
                  “{item.quote}”
                </blockquote>
                <figcaption className="mt-4" data-id="element-251" data-mp="2205suz1lm89b">
                  <span className="block font-display text-sm font-bold text-forest-950" data-id="element-252" data-mp="ln78a4qsxr9l">
                    {item.name}
                  </span>
                  <span className="mt-1 block text-xs text-forest-600/80" data-id="element-253" data-mp="qnbt26yqt85m">
                    {item.location} · {item.product}
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}